import { render } from "./ModalResult.vue?vue&type=template&id=5f3ec722&scoped=true"
import script from "./ModalResult.vue?vue&type=script&lang=js"
export * from "./ModalResult.vue?vue&type=script&lang=js"

import "./ModalResult.vue?vue&type=style&index=0&id=5f3ec722&scoped=true&lang=css"

import exportComponent from "/home/user/dev/teacher-soft/datepickerDev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3ec722"]])

export default __exports__